import { Modal, Button, Badge } from "react-bootstrap";
import DownloadButton from "../../Buttons/DownloadButton";
import { useTranslation } from "react-i18next";
import "./GalleryModal.css";
import { removeItem } from "../../../Reducers/cartReducer";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import AddToCartButton from "../../Buttons/AddToCartButton";

function GalleryModal({ show, handleClose, item, isDocument = false }) {
  const [showRemove, setShowRemove] = useState(false);

  const { t } = useTranslation();

  const cartItems = useSelector((state) => state.cart.items);

  const dispatch = useDispatch();

  useEffect(() => {
    const existingItem = cartItems.find(
      (el) => el.globalAssetId === item.globalAssetId
    );

    if (existingItem) {
      setShowRemove(true);
    }
  }, []);

  useEffect(() => {
    const existingItem = cartItems.find(
      (el) => el.globalAssetId === item.globalAssetId
    );

    if (!existingItem) {
      setShowRemove(false);
    } else {
      setShowRemove(true);
    }
  }, [cartItems]);

  const removeFromCart = (e) => {
    e.stopPropagation();
    dispatch(removeItem(item.globalAssetId));
    setShowRemove(false);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop>
        <Modal.Header className="d-flex flex-column">
          <div
            className={`modal-media w-100 ${
              item?.type === "video" ? "video" : ""
            }`}
          >
            {item && item.type === "video" ? (
              item.proxyUrl ? (
                <video controls>
                  <source
                    src={item.proxyUrl || ""}
                    type="video/mp4"
                    style={{ objectFit: "contain" }}
                  />
                </video>
              ) : (
                ""
              )
            ) : item.coverUrl ? (
              <img
                src={isDocument ? item?.coverUrl : item.proxyUrl}
                alt="modal thumbnail"
              />
            ) : (
              ""
            )}
          </div>
          <div className="w-100 d-flex flex-row justify-content-end">
            {!showRemove ? (
              <>
                <DownloadButton item={item} />
                {item.type !== "video" && (
                  <AddToCartButton item={item} setShow={setShowRemove} />
                )}
              </>
            ) : (
              <Badge
                bg="danger"
                className="custom-button position-static pull-right"
                role="button"
                onClick={(e) => removeFromCart(e)}
              >
                {t("remove")}
              </Badge>
            )}
          </div>
        </Modal.Header>
        <Modal.Body>
          {item.downloads !== 0 ? (
            <div>
              <Badge className="position-static" bg="success">
                {item.downloads} {t("downloaded")}
              </Badge>
            </div>
          ) : (
            ""
          )}
          {item.publishingDate && (
            <div>
              <strong>{t("published_on")}:</strong>{" "}
              <Badge className="position-static" bg="secondary">
                {item.publishingDate.slice(0, 10)}{" "}
                {item.publishingDate.slice(11, 19)}
              </Badge>
            </div>
          )}
          {item.title && (
            <div>
              <strong>{t("title")}:</strong> {item.title}
            </div>
          )}
          {item.ship && (
            <div>
              <strong>{t("ship")}:</strong> {item.ship}
            </div>
          )}
          {item.onboard && (
            <div>
              <strong>{t("on_board")}:</strong> {item.onboard}
            </div>
          )}
          {item.description && (
            <div>
              <strong>Info:</strong> {item.description}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleClose}>
            {t("close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default GalleryModal;
